import gql from 'graphql-tag'
import { getProvider } from '../../../apollo'
import { splitError } from '../../../helper/splitError'

const initialState = {
  reset: {
    step: 'token',
    token: null
  }
}

const ResetPasswordModule = {
  namespaced: true,
  state: initialState,
  actions: {
    async resetPassword ({ commit, state, rootGetters }, { password, birthdate, nextStep = 'finalizeProcess' }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation resetPasswordConfirmation ($input: ResetPasswordConfirmInput!){
          setNewPassword (resetPasswordConfirm: $input) {
            success
          }
        }`,
        variables: {
          input: {
            token: state.reset.token,
            brand: rootGetters.brand,
            newPassword: password,
            birthdate: birthdate
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'resetPasswordConfirmation', { root: true })
        commit(nextStep)
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    captureToken (state, token, nextStep = 'password') {
      if (token) {
        state.reset.token = token
        state.reset.step = nextStep
      } else {
        state.reset.step = 'token'
      }
    },
    finalizeProcess (state, nextStep = 'success') {
      state.reset.token = null
      state.reset.step = nextStep
    },
    resetProcess: (state) => {
      state = initialState
    }
  },
  getters: {
    step (state) {
      return state.reset.step
    }
  }
}

export {
  ResetPasswordModule
}
